import chooseImages from './choose-images.js';
import container from './container.js';
import gravatar from './gravatar.js';

export default {
    chooseImages,
    container,
    gravatar
};
